import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./styles/main.css";
import HeroSection from "./components/HeroSection";
import LoanLeadForm from "./components/LoanLeadForm";
import AdminLogin from "./components/AdminLogin";
import AdminLeads from "./components/AdminLeads";
import VerifyPage from "./components/VerifyPage";

function Home() {
  return (
    <div className="landing-page">

      {/* ── Header ── */}
      <header className="site-header">
        <a href="/"><img src="/logo.jpeg" alt="Uni Global Education Consultancy" className="header-logo" /></a>
        <div className="header-center">
          <a href="tel:+919177454500" className="header-contact-item">
            <span>📞</span> +91 9177454500
          </a>
          <a href="mailto:info@uniglobaleducon.com" className="header-contact-item">
            <span>✉️</span> info@uniglobaleducon.com
          </a>
        </div>
        <a href="tel:+917429992222" className="header-contact-btn">
          <span>📞</span><span>+91 7429992222</span>
        </a>
      </header>

      {/* ── Hero ── */}
      <HeroSection />

      {/* ── Loan Form ── */}
      <section id="apply" className="apply-section">
        <div className="form-card">
          <LoanLeadForm />
          <div className="card-footer">
            <p>
              <strong>+91 742 999 2222</strong>&nbsp;|&nbsp;
              <a href="https://uniglobaleducon.com/" target="_blank" rel="noreferrer">
                uniglobaleducon.com
              </a>
            </p>
            <p>1st Floor, 4-5-40/1, Kalyani Road, Vinayak Nagar, Guntur, AP – 522007</p>
          </div>
        </div>
      </section>

      {/* ── Footer ── */}
      <footer className="site-footer">
        <p>© 2025 Uni Global Education Consultancy Pvt. Ltd. All rights reserved.</p>
      </footer>

    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/leads" element={<AdminLeads />} />
        <Route path="/verify/:token" element={<VerifyPage />} />
      </Routes>
    </BrowserRouter>
  );
}
